import {PIXI} from '@colonist/pixi'
import {CardView} from '../../../../shared/scripts/ui_canvas_engine/CardView'
import {RibbonCountView} from '../../../../shared/scripts/ui_canvas_engine/RibbonCountView'
import {SectionView} from '../../../../shared/scripts/ui_canvas_engine/SectionView'
import {TextTruncatedView} from '../../../../shared/scripts/ui_canvas_engine/TextTruncatedView'
import {UIGamePlayerAvatarView} from '../../../../shared/scripts/ui_game/ui_game_players/UIGamePlayerAvatarView'
import {UIGamePlayerInformationView, UIPlayerAdditionalInformationLayer} from '../../../../shared/scripts/ui_game/ui_game_players/UIGamePlayerInformationView'
import {TranslationObject} from '@colonist/i18n'
import {AdaptiveSpriteSectionView} from '../../../../shared/scripts/ui_canvas_engine/AdaptiveSpriteSectionView'
import {GameColor} from '../../../../shared/scripts/GameColor'
import {SpriteView} from '../../../../shared/scripts/ui_canvas_engine/SpriteView'
import {UIGameManager} from '../../../../shared/scripts/ui_game/UIGameManager'
import {PlayerValidator, MechanicValidatorDevelopmentCardPlayer, MechanicValidatorProgressCardsPlayer} from '@colonist/game-mechanic-validators'
import {UIGameConstants} from '../../../../shared/scripts/ui_game/UIGameConstants'
import {UIMGamePlayerInformationDropdownController} from './UIMGamePlayerInformationDropdownController'
import {UIMGamePlayerInformationPlacementsView} from './UIMGamePlayerInformationPlacementsView'
import {SectionBgView} from '../../../../shared/scripts/ui_canvas_engine/SectionBgView'
import {bringToFront} from '../../../../shared/scripts/ui_utils/PixiUtils'
import {UIUtilsEjsVariables} from '../../../../shared/scripts/UIUtilsEjsVariables'
import {UIGameSpriteHandler} from '../../../../shared/scripts/UIGameSpriteHandler'
import {CardEnum,
    MechanicCityImprovementsPlayerState,
    MechanicCityPlayerState,
    MechanicCityWallPlayerState,
    MechanicLargestArmyPlayerState,
    MechanicLongestRoadPlayerState,
    MechanicRoadPlayerState,
    MechanicSettlementPlayerState,
    MechanicSpecialBuildPhaseState,
    PlayerState,
} from '@colonist/game-states'
import {UIGamePlayerInformationSpecialBuildPhaseFlagController} from '../../../../shared/scripts/ui_game/ui_game_special_build_phase/UIGamePlayerInformationSpecialBuildPhaseFlagController'

export class UIMGamePlayerInformationView extends UIGamePlayerInformationView {
    private statsHolder: SectionBgView
    private highlightView: SpriteView
    private shouldShowHighlight: boolean
    isLeftAligned: boolean
    private readonly dropdownInformationView: UIMGamePlayerInformationDropdownController

    constructor(uiGameManager: UIGameManager, player: PlayerValidator, playerState: PlayerState, x: number, y: number, w: number, h: number, container: PIXI.Container, myPlayer: boolean,
                developmentCardsPlayerState: MechanicValidatorDevelopmentCardPlayer | undefined,
                progressCardsPlayerValidator: MechanicValidatorProgressCardsPlayer | undefined,
                settlementPlayerState: MechanicSettlementPlayerState | undefined,
                cityPlayerState: MechanicCityPlayerState | undefined,
                cityWallPlayerState: MechanicCityWallPlayerState | undefined,
                cityImprovementsPlayerState: MechanicCityImprovementsPlayerState | undefined,
                roadPlayerState: MechanicRoadPlayerState | undefined,
                longestRoadPlayerState: MechanicLongestRoadPlayerState | undefined,
                largestArmyPlayerState: MechanicLargestArmyPlayerState | undefined,
                specialBuildPhaseState: MechanicSpecialBuildPhaseState | undefined) {
        super(uiGameManager, player, playerState, x, y, w, h, container, myPlayer,
            developmentCardsPlayerState,
            progressCardsPlayerValidator,
            settlementPlayerState,
            cityPlayerState,
            cityWallPlayerState,
            cityImprovementsPlayerState,
            roadPlayerState,
            longestRoadPlayerState,
            largestArmyPlayerState,
            specialBuildPhaseState)

        const spaceForDices = 15
        this.dropdownInformationView = new UIMGamePlayerInformationDropdownController(this.uiGameManager, this, this.isLeftAligned, spaceForDices)
        new UIMGamePlayerInformationPlacementsView(this.uiGameManager, this)
        this.createOpponentUsernameBox()

        this.position.x += this.isLeftAligned ? -spaceForDices : spaceForDices
        this.inititiatePlayerInformationSpecialBuildPhaseFlagViews()
    }

    protected createMyPlayerNameAndImage() {
        // design: https://www.figma.com/file/U2GMIvGeBKSuhEPWqrkLas/Player-Info-Final?node-id=0%3A1
        this.createOpponentPlayerNameAndImage()
    }

    protected updateTextView() {
        if(this.playerName == undefined) return
        this.playerName.setText({key: 'strings:colonistCommon.utils.#buffer', options: {value: this.player.username}})
    }

    protected createMySpecialIconView() {
        // design: https://www.figma.com/file/KjHdwcS3tBLtE3DXFKyJQK/Mobile-Game-Master-File?type=design&node-id=987-253268&t=4SDQl5RZOJaszEKv-4
        this.createOpponentSpecialIconView()
    }

    protected createOpponentPlayerNameAndImage() {
        this.setLeftAligned()
        this.createStatsHolder()
        this.createActivePlayerHighlight()

        const playerAvatarW = this.width * 0.25
        const playerAvatarX = this.isLeftAligned ? this.highlightView.width - playerAvatarW - this.width * 0.1 : this.width * 0.1
        const playerAvatarY = - this.statsHolder.height * 0.015
        this.playerAvatar = new UIGamePlayerAvatarView(playerAvatarX, playerAvatarY, playerAvatarW, this, this.player)

        const largeRibbon = false
        const victoryPointRibbonW = playerAvatarW * 1.2
        const victoryPointRibbonH = victoryPointRibbonW * 0.35
        const victoryPointRibbonX = playerAvatarX - playerAvatarW * 0.1
        const victoryPointRibbonY = playerAvatarY + playerAvatarW * 0.63
        this.victoryPointRibbon = new RibbonCountView(victoryPointRibbonX, victoryPointRibbonY, victoryPointRibbonW, victoryPointRibbonH, this, largeRibbon)
        const vpToWin = this.uiGameManager.gameController.gameSettings.victoryPointsToWin
        const vpToWinTooltipTitle: TranslationObject = {key: 'strings:game.playerInformation.victoryPoint.title'}
        const vpToWinTooltipBody: TranslationObject = {
            key: 'strings:game.playerInformation.victoryPoint.body',
            options: {count: vpToWin},
        }
        this.victoryPointRibbon.setTip(vpToWinTooltipTitle, [vpToWinTooltipBody])

        this.createOpponentCardSection()
        this.createOpponentSpecialIconView()
        bringToFront(this.playerAvatar)
        bringToFront(this.victoryPointRibbon)
        bringToFront(this.specialIconView)
    }

    private setLeftAligned() {
        if(UIUtilsEjsVariables.isUserOnTabletApp) {
            this.isLeftAligned = false
            return
        }

        const isPositionOnLeftHalf = this.position.x < this.uiGameManager.canvasController.itemSize
        this.isLeftAligned = isPositionOnLeftHalf
    }

    private createOpponentUsernameBox() {
        const container = this.getContainerForAdditionalPlayerInformation(UIPlayerAdditionalInformationLayer.Layer0)
        const playerNameSectionW = container.width * 0.9
        const playerNameSectionH = container.height * 0.4

        const playerNameSectionX = container.width * 0.1
        const playerNameSectionY = container.height * 0.1
        const removePadding = true
        const playerNameSection = new SectionView(playerNameSectionX, playerNameSectionY, playerNameSectionW, playerNameSectionH, container, removePadding)
        const fontSize = container.height * 0.25
        this.playerName = new TextTruncatedView({key: 'strings:colonistCommon.utils.emptyString'}, 0, 0, playerNameSectionW, playerNameSectionH, playerNameSection, fontSize, GameColor.getColor(GameColor.Color.White))
        if(this.uiGameManager.gameController.myColor == this.player.color) this.playerName.makeBold()
        this.updateTextView()
    }

    private createStatsHolder() {
        const statsHolderW = this.width * 0.825
        const x = this.isLeftAligned ? 0 : this.width - statsHolderW
        const y = this.height * 0.05
        const h = this.height * 0.95
        this.statsHolder = new SectionBgView(x, y, statsHolderW, h, this, true)
        const color = (this.uiGameManager.gameController.myColor == this.player.color) ? GameColor.getColorHexValue(GameColor.Color.PrimaryBlue9) : GameColor.getColorHexValue(GameColor.Color.PrimaryBlue6)
        this.statsHolder.drawBg(color, 1)
    }

    private createActivePlayerHighlight() {
        const texture = this.isLeftAligned ? UIGameSpriteHandler.getTexture('player_highlight_left') : UIGameSpriteHandler.getTexture('player_highlight_right')
        if(texture == undefined) return
        const statsHolderX = 0
        const statsHolderY = 0
        const statsHolderW = this.width
        const statsHolderH = texture.height / texture.width * statsHolderW
        this.highlightView = new SpriteView(statsHolderX, statsHolderY, statsHolderW, statsHolderH, this, texture, 0)
        this.highlightView.visible = false
        if(this.isLeftAligned) return
        this.highlightView.x = this.width - this.highlightView.width
    }

    private createOpponentCardSection() {
        // design: https://www.figma.com/file/U2GMIvGeBKSuhEPWqrkLas/Player-Info-Final?node-id=0%3A1
        const resourceCardCount = 0
        const resourceCardX = this.playerAvatar.position.x - this.statsHolder.width * 0.115
        const resourceCardY = this.statsHolder.height * 0.18
        const cardW = this.statsHolder.width * 0.17
        const cardH = cardW * UIGameConstants.CARD_RATIO
        this.resourceCardView = new CardView(resourceCardCount, resourceCardX, resourceCardY, cardW, cardH, CardEnum.ResourceBack, this)
        this.resourceCardView.rotation = -15 * Math.PI / 180
        const developmentCardCount = 0
        const developmentCardX = this.isLeftAligned ? resourceCardX + this.statsHolder.width * 0.53 : resourceCardX + this.statsHolder.width * 0.53
        const developmentCardY = resourceCardY
        const forceCardBadge = true
        this.developmentCardView = new CardView(developmentCardCount, developmentCardX, developmentCardY, cardW, cardH, CardEnum.DevelopmentBack, this, undefined, forceCardBadge)
        this.developmentCardView.pivot.x = this.developmentCardView.width
        this.developmentCardView.rotation = 15 * Math.PI / 180
    }

    private createOpponentSpecialIconView() {
        // design: https://www.figma.com/file/U2GMIvGeBKSuhEPWqrkLas/Player-Info-Final?node-id=0%3A1
        const specialIconViewW = (this.developmentCardView.x - this.resourceCardView.x) * 0.6
        const specialIconViewX = this.resourceCardView.x + (this.developmentCardView.x - this.resourceCardView.x) * 0.2
        const specialIconViewY = this.height * 0.7
        const specialIconViewH = this.height * 0.3

        const isPrimaryAxisHorizontal = true
        this.specialIconView = new AdaptiveSpriteSectionView(specialIconViewX, specialIconViewY, specialIconViewW, specialIconViewH, this, isPrimaryAxisHorizontal)
    }

    protected updateTurn() {
        const playersToHighlight = this.getPlayersToHighlight()

        this.shouldShowHighlight = playersToHighlight.includes(this.player.color)
        if(this.highlightView == undefined) return
        this.highlightView.visible = this.shouldShowHighlight
    }

    getContainerForAdditionalPlayerInformation(layerIndex: UIPlayerAdditionalInformationLayer): PIXI.Container {
        return this.dropdownInformationView.dropdownInformationViews[layerIndex]
    }

    private inititiatePlayerInformationSpecialBuildPhaseFlagViews() {
        if(this.uiGameManager.gameController.isReplay) return
        if(this.uiGameManager.playersController == undefined) return
        for(const playerInformation of this.uiGameManager.playersController.playerInformationViews) {
            new UIGamePlayerInformationSpecialBuildPhaseFlagController(this.uiGameManager, playerInformation)
        }
    }
}
